export default __webpack_public_path__ + "static/media/dots.f32a48e4.svg";